import {
  AIR_CARGO_RESET_FILTER,
  AIR_CARGO_APPLY_SORT,
  AIR_CARGO_APPLY_FILTERS,
  AIR_CARGO_SET_DATA,
  AIR_CARGO_SET_SEARCH_RESULTS,
  AIR_CARGO_SET_PAGINATION,
  AIR_CARGO_RESET_PAGINATION,
  AIR_CARGO_SET_IS_COMPLETE,
  AIR_CARGO_SET_IS_LOADING,
  AIR_CARGO_SET_FILTER_TAGS,
  AIR_CARGO_SET_STATUS,
  AIR_CARGO_SET_PAGES,
  AIR_CARGO_SET_TABID,
  AIR_CARGO_SET_SELECTED_FILTERS,
  AIR_CARGO_RESET_SELECTED_FILTERS,
  AIR_CARGO_SET_DETAIL_VIEW_ID,
  AIR_CARGO_REFRESH,
  RECENT_HAWB_FILTERS_LOADING,
  SET_RECENT_HAWB_FILTERS,
} from 'src/actions/constants';
const initialState = {
  filters: {  
    endDate: undefined,
    startDate: undefined,
    timeFilter: '6M',
    airLineList: [],
    timeFilterType: 'created_at',
    ffIdList: [],
    productList: [],
    customerList: [],
    supplierList: [],
    originPortList: [],
    destinationPortList: [],
    accessTypeFilters: [],
    awbIdList: [],
    statusList: [],
    hawbIdList: [],
    hawbVendorList: [],
  },
  selectedFilters: {
    customerList: [],
    airlineList: [],
    destinationPortList: [],
    originPortList: [],
    productList: [],
    awbIdList: [],
    hawbIdList: [],
    hawbVendorList: [],
  },
  statusCounts: {
    CANCELLED: 0,
    COMPLETED: 0,
    DELAYED: 0,
    IN_FLIGHT: 0,
    ON_GROUND: 0,
    SCHEDULED: 0,
    TOTAL: 0,
    UNAVAILABLE: 0,
  },
  tabId: 'TOTAL',
  totalPages: 1,
  filterTagsList: [],
  isLoading: false,
  sortBy: 'updatedAt',
  isComplete: false,
  descendingOrder: true,
  cardList: [],
  searchResults: [],
  pagination: {
    nextOrPrev: 'first',
    currentPageNumber: 1,
    resultPerPage: 25,
    lastAwbId: null,
    lastSortedColumnValue: null,
  },
  currentDetailsViewId: null
};
const applySort = (sortByObject, state) => {
  return {
    ...state,
    ...sortByObject,
  };
}
const applyFilters = (filters, state) => {
  return {
    ...state,
    filters: {
      ...state.filters,
      ...filters,
    },
  };
}

const applyRefresh = (ids, state) => {
  const hashMap = new Set();
  ids.forEach(id => hashMap.add(String(id)));
  const updatedCardList = state?.cardsList.map(element => {
    if (hashMap.has(String(element?.id))) {
      element.trackingStatus = 'PENDING'
    }
    return element;
  });
  return {
    ...state,
    cardsList: [...updatedCardList]
  }
}

const setSearchResults = (searchResults, state) => {
  return {
    ...state,
    searchResults,
  };
}
const setData = (cardsList, state) => {
  return {
    ...state,
    cardsList,
  };
}
const setPagination = (pagination, state) => {
  return {
    ...state,
    pagination,
  };
}
export default function (state = initialState, action) {
  switch (action.type) {
    case AIR_CARGO_RESET_FILTER: {
      return {
        ...state,
        filters: initialState.filters,
      }
    }
    case AIR_CARGO_APPLY_SORT: {
      return applySort(action.data, state);
    }
    case AIR_CARGO_APPLY_FILTERS: {
      return applyFilters(action.data, state);
    }
    case AIR_CARGO_SET_DATA: {
      return setData(action.data, state);
    }
    case AIR_CARGO_SET_SEARCH_RESULTS: {
      return setSearchResults(action.data, state);
    }
    case AIR_CARGO_SET_PAGINATION: {
      return setPagination(action.data, state);
    }
    case AIR_CARGO_SET_IS_COMPLETE: {
      return {
        ...state,
        isComplete: action.data,
      };
    }
    case AIR_CARGO_SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.data,
      };
    }
    case AIR_CARGO_SET_FILTER_TAGS: {
      return {
        ...state,
        filterTagsList: action.data,
      };
    }
    case AIR_CARGO_SET_STATUS: {
      return {
        ...state,
        statusCounts: action.data,
      };
    }
    case AIR_CARGO_SET_PAGES: {
      return {
        ...state,
        totalPages: action.data,
      };
    }
    case AIR_CARGO_SET_TABID: {
      return {
        ...state,
        tabId: action.data,
      };
    }
    case AIR_CARGO_SET_SELECTED_FILTERS: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.data,
        }
      };
    }
    case AIR_CARGO_RESET_SELECTED_FILTERS: {
      return {
        ...state,
        selectedFilters: initialState.selectedFilters,
      }
    }
    case AIR_CARGO_RESET_PAGINATION: {
      return {
        ...state,
        pagination: initialState.pagination,
      };
    }
    case AIR_CARGO_SET_DETAIL_VIEW_ID: {
      return {
        ...state,
        currentDetailsViewId: action.data
      }
    }
    case AIR_CARGO_REFRESH: {
      return applyRefresh(action.data, state);
    }
    case RECENT_HAWB_FILTERS_LOADING: {
      return {
        ...state,
        isRecentFiltersLoading: action.data
      }
    }
    case SET_RECENT_HAWB_FILTERS: {
      return {
        ...state,
        recentHAWBFilters: action.data
      }
    }
    default: return state;
  }
};